import styled from 'styled-components';

import useTranslation from 'shared/hooks/useTranslation';

import { Description, Header, Section, StyledH2 } from '../Styled';

import Trans from 'next-translate/Trans';
import Image from 'next/image';

const StyledSection = styled(Section)`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const StyledH2WithSpanColor = styled(StyledH2)`
  span {
    color: #fc8000;
  }
`;

const StyledDescription = styled(Description)`
  margin: 0 auto;
  max-width: 105rem;
`;

interface ImageWrapperProps {
  maxWidth: number;
}

const ImageWrapper = styled.div<ImageWrapperProps>`
  @media (max-width: ${({ theme }) => theme.BREAKPOINT.MD}) {
    width: 90%;
  }

  margin: 0 auto;
  position: relative;
  max-width: ${({ maxWidth }) => `${maxWidth}px`};

  @media ${({ theme }) => theme.DEVICE.XL} {
    width: 100%;
    transform: translateX(0);
    height: auto;
  }
`;

function SurveysStart(): JSX.Element {
  const { t, lang } = useTranslation('surveysPage');

  return (
    <StyledSection>
      <Header>
        <StyledH2WithSpanColor>
          <Trans
            i18nKey="surveysPage:howToRunPoll.topText"
            components={[<span key="statistics" />]}
            fallback="surveysPageEN:howToRunPoll.topText"
          />
        </StyledH2WithSpanColor>
        <StyledDescription>{t('howToRunPoll.description')}</StyledDescription>
      </Header>
      <ImageWrapper maxWidth={1228}>
        <Image
          src={`/img/surveys/v2/${lang === 'pl' ? 'pl' : 'en'}/surveys-with-phone.png`}
          alt=""
          width={1608}
          height={621}
          lazyBoundary="1000px"
          layout="responsive"
        />
      </ImageWrapper>
    </StyledSection>
  );
}

export default SurveysStart;
